import classNames from 'classnames';

import styles from './ScrollContainer.module.scss';
import { ScrollContainerProps } from './ScrollContainer.types';

export function ScrollContainer({
  active,
  children,
  className,
}: ScrollContainerProps) {
  if (!active) return <>{children}</>;
  return (
    <div className={classNames(styles.container, className)}>
      <div className={styles.inner}>{children}</div>
    </div>
  );
}
